import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import CtaStyle2 from '../Cta/CtaStyle2';
import AboutStyle7 from '../About/AboutStyle7';
import AboutStyle8 from '../About/AboutStyle8';
import { pageTitle } from '../../helpers/PageTitle';

export default function CaseStudyDetailsPage() {
  pageTitle('Case Study Details');
  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Custom software <br/>development project"
        subTitle="Technology"
        variant="text-center"
      />
      <Spacing lg="75" md="60" />

      <div className="container">
        <img
          className="cs_casestudy_details_thumb cs_radius_15"
          src="/images/others/case_1.jpeg"
          alt="Thumb"
        />
        <div className="cs_height_100 cs_height_lg_60" />
        <ul className="cs_case_study_info cs_mp0">
          <li>
            <p className="mb-0">Client</p>
            <h3 className="cs_fs_21 mb-0 cs_semibold">Andreo Bowla</h3>
          </li>
          <li>
            <p className="mb-0">Location </p>
            <h3 className="cs_fs_21 mb-0 cs_semibold">United Kindom</h3>
          </li>
          <li>
            <p className="mb-0">Budgets</p>
            <h3 className="cs_fs_21 mb-0 cs_semibold">$1330 USD</h3>
          </li>
          <li>
            <p className="mb-0">Completed</p>
            <h3 className="cs_fs_21 mb-0 cs_semibold">12 April 2023</h3>
          </li>
        </ul>
        <div className="cs_height_100 cs_height_lg_60" />
        <div className="row align-items-center cs_gap_y_35">
          <div className="col-lg-5">
            <img
              src="/images/others/case_2.jpeg"
              alt="Thumb"
              className="cs_radius_15 w-100"
            />
          </div>
          <div className="col-lg-6 offset-lg-1">
            <h2 className="cs_fs_50">Project Brief :</h2>
            <div className="cs_height_15 cs_height_lg_15" />
            <p>
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem
              accusantium loposepas doloremque own laudantium, totam rem
              aperiam, eaque ipsa quae ab illo inventore veritatis et quasi
              holas architecto beatae vitae dicta sunt explicabo. Nemo enim
              ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit,
              sed quia environmet consequuntur magni dolores eos qui ratione
              mone voluptatem sequi nesciunt. Neque porro quisquam est world
              wide.
            </p>
            <p>
              SAW Technologies team delivered a comprehensive custom software solution that transformed the client's business operations. We combined modern development practices with cloud-native architecture to build a scalable, secure platform that drives efficiency and growth.
            </p>
            <div className="cs_height_20 cs_height_lg_10" />
            <p className="mb-0">
              Website:{' '}
              <a href="/" className="cs_accent_color">
                www.sawtechnologies.com
              </a>
            </p>
          </div>
        </div>
      </div>
      <Spacing lg="150" md="80" />
      <AboutStyle7
        title="Challenging part:"
        subTitle="Building a scalable cloud-native application that could handle high traffic volumes while maintaining performance. We implemented microservices architecture with automated DevOps pipelines for seamless deployment and monitoring."
        featureList={[
          { number: '01', text: 'Scalable Architecture Design' },
          { number: '02', text: 'Cloud Infrastructure Setup' },
          { number: '03', text: 'API Development & Integration' },
          { number: '04', text: 'Performance Optimization' },
          { number: '05', text: 'Security Hardening' },
          { number: '06', text: 'DevOps Automation' },
        ]}
        thumbnailSrc="/images/others/case_3.jpeg"
      />
      <Spacing lg="150" md="80" />
      <AboutStyle8
        thumbnailSrc="/images/others/case_4.jpeg"
        title="Result overview:"
        subTitle="The delivered solution exceeded expectations with improved system performance, reduced operational costs, and enhanced user experience. The client saw immediate business impact with increased efficiency and scalability for future growth."
        grothData={[
          { title: 'Performance Increase', percentage: '95' },
          { title: 'Cost Reduction', percentage: '40' },
          { title: 'User Satisfaction', percentage: '90' },
        ]}
      />
      <Spacing lg="140" md="70" />
      <CtaStyle2
        title="Is there a specific project or goal <br />that you have in mind?"
        btnText="Send Message"
        btnUrl="/contact"
      />
      <div className="cs_height_150 cs_height_lg_80" />
    </>
  );
}
